import { Header } from '../../components/Header/Header';
import LayoutTab from '../../components/LayoutTab/LayoutTab';
import { useSidePanelPersistence } from '../../hooks/use-persisted-state';

export const Home = () => {
  useSidePanelPersistence();
  return (
    <div className="flex h-full w-full flex-col">
      <Header classNames="bg-mono-1 sticky top-0 left-0 z-40 w-full py-2 mt-1 px-2" />
      <LayoutTab />
    </div>
  );
};
